import * as React from 'react';
import { useState } from 'react';
import { useDataProvider } from 'react-admin';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import isTest from './isTest';
import LogoBW from '../img/logo.svg';

import {
    Stack,
    Card,
    CircularProgress,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
} from '@mui/material';
import {
    useTranslate,
    useLogin,
    useNotify,
} from 'react-admin';

import Box from '@mui/material/Box';

const Login = () => {
    const [values, setValues] = useState({username:'', password:'', hostel:'',  appuser:'', apppassword:'', fa2:'', trustdevice:false});
    const [loading, setLoading] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [errors, setErrors] = useState({});
    const [token, setToken] = useState('');
    const [email, setEmail] = useState('');
    const translate = useTranslate();
    const dataProvider = useDataProvider();

    const notify = useNotify();
    const login = useLogin();
    const location = useLocation();

    var get = {};
    if (!clicked) {
      var parts = window.location.search.substr(1).split("&");
      for (var i = 0; i < parts.length; i++) {
        var temp = parts[i].split("=");
        get[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
      }
    }
    const appLogin = isTest || new URLSearchParams(window.location.search).get('applogin') === '1';

    const setFieldValue = (field) => (e) => {
      const newValues = {...values, [field]: e.target.value };
        setValues(newValues);
        validate(newValues);
    }

    const validate = (v) => {
      if (!v) v = values;
      const errors = {};
                    
      if (token) {
        if (v.fa2 && v.fa2.length===6) {
          setErrors({});
          return;
        }
        errors.fa2 = '6 Digit code required';
      }
      if (v.username) {
        if (!v.password) {
            errors.password = translate('ra.validation.required');
        }
      }
      else if(v.hostel) {
        if (!v.appuser) {
            errors.appuser = translate('ra.validation.required');
        }
      }
      else if(v.appuser) {
        if (!v.hostel) {
            errors.hostel = translate('ra.validation.required');
        }
      }
      setErrors(errors);
    };
    
    const handleSubmit = () => {
      setLoading(true);
      setClicked(true);
      if (values.appuser && !token) {
        dataProvider.update('authToken', { id:0, data: values})
          .then(res  => {
              if (res.data.token) {
                  setToken(res.data.token);
                  setEmail(res.data.email);
              }
              else {
                  notify('ra.auth.sign_in_error', { type: 'warning' });
              }
              setLoading(false);
          })
          .catch(() => {
              setLoading(false);
              setToken('');
              setEmail('');
              notify('ra.auth.sign_in_error', { type: 'warning' });
          })
      }
      else {
          const auth = token?{token:token, fa2:values.fa2, trustdevice:values.trustdevice}:{...values, token:get.token};
        login(
            auth,
            location.state ? (location.state as any).nextPathname : '/'
        ).catch((error: Error) => {
            setLoading(false);
            notify(
                typeof error === 'string'
                    ? error
                    : typeof error === 'undefined' || !error.message
                    ? 'ra.auth.sign_in_error'
                    : error.message,
                {
                    type: 'warning',
                    messageArgs: {
                        _:
                            typeof error === 'string'
                                ? error
                                : error && error.message
                                ? error.message
                                : undefined,
                    },
                }
            );
        });
      }
    };

    const handleBack = () => {
      setToken('');
      setEmail('');
      setLoading(false);
      setErrors({});
        setValues({...values, apppassword:'', fa2:'', trustdevice:false});
    };

    const diabledSignIn = loading || (!get.token && (Object.keys(errors).length > 0  || (!values.username && !values.appuser)));

    return (
      <Box
          sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
              alignItems: 'center',
              justifyContent: 'flex-start',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: isTest?'#D02628':'#002D7A',
          }}
      >
          <Card component="form" onSubmit={(e) => { e.preventDefault(); if (!diabledSignIn) handleSubmit(); }} sx={{ minWidth: 300, marginTop: '6em', textAlign: 'center' }}>
            <Box
                sx={{
                    margin: '1em',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <img src={LogoBW} alt="Logo book.world" />
            </Box>
      {!get.token && !loading && !token &&
            <Stack direction="row" >
              <Box sx={{ padding: '0 1em 0 1em' }}>
                <h3 style={{marginBottom:0}}>with Admin User</h3>
                <Box>
                  <TextField
                    autoFocus
                    id="username"
                    name="username"
                    value={values.username}
                    onChange={setFieldValue('username')}
                    inputProps={{} /* ueberschreibt data-lpignore aus dem theme: lastpass soll das login ausfuellen */}
                    label="Username"
                    disabled={loading || !!values.hostel || !!values.appuser}
                    error={!!errors.username}
                    helperText={errors.username}
                    fullWidth
                  />
                </Box>
                <Box sx={{ marginTop: '0.2em' }}>
                  <TextField
                    id="password"
                    name="password"
                    value={values.password}
                    onChange={setFieldValue('password')}
                    inputProps={{} /* ueberschreibt data-lpignore aus dem theme: lastpass soll das login ausfuellen */}
                    label="Password"
                    type="password"
                    disabled={loading || !!values.hostel || !!values.appuser}
                    error={!!errors.password}
                    helperText={errors.password}
                    fullWidth
                  />
                </Box>
              </Box>
   {appLogin &&
              <Box sx={{ padding: '0 1em 0 1em', borderLeft: '1px solid #ccc' }}>
                <h3 style={{marginBottom:0}}>with App User</h3>
                <Box>
                  <TextField
                    id="hostel"
                    name="hostel"
                    value={values.hostel}
                    onChange={setFieldValue('hostel')}
                    inputProps={{} /* ueberschreibt data-lpignore aus dem theme: lastpass soll das login ausfuellen */}
                    label="Hostel-Ident / ID"
                    disabled={loading || !!values.username}
                    error={!!errors.hostel}
                    helperText={errors.hostel}
                    fullWidth
                  />
                </Box>
                <Box>
                  <TextField
                    id="appuser"
                    name="appuser"
                    value={values.appuser}
                    onChange={setFieldValue('appuser')}
                    inputProps={{} /* ueberschreibt data-lpignore aus dem theme: lastpass soll das login ausfuellen */}
                    label="App-User"
                    disabled={loading || !!values.username}
                    error={!!errors.appuser}
                    helperText={errors.appuser}
                    fullWidth
                  />
                </Box>
                <Box sx={{ marginTop: '0.2em' }}>
                  <TextField
                    id="apppassword"
                    name="apppassword"
                    value={values.apppassword}
                    onChange={setFieldValue('apppassword')}
                    inputProps={{} /* ueberschreibt data-lpignore aus dem theme: lastpass soll das login ausfuellen */}
                    label="App-Password"
                    type="password"
                    disabled={loading || !!values.username}
                    fullWidth
                  />
                </Box>
              </Box>
  }
          </Stack>
        }
        {token && email &&
              <Box sx={{ padding: '0 1em 0 1em' }}>
                <h3 style={{marginBottom:0}}>we have sent an email to<br/>{email} with the 2nd factor code.<br/>Please enter the code below.</h3>
                <Box>
                  <TextField
                    autoFocus
                    id="fa2"
                    name="fa2"
                    value={values.fa2}
                    onChange={setFieldValue('fa2')}
                    label="2nd Factor Code"
                    disabled={loading}
                    error={!!errors.fa2}
                    helperText={errors.fa2}
                    fullWidth
                  />
                </Box>
                <FormControlLabel
                  control={<Checkbox checked={values.trustdevice} onChange={(e) => setValues({...values, trustdevice:e.target.checked})} disabled={loading} />}
                  label="Trust this device for 2 days"
                />
              </Box>
        }
        {token && !email &&
              <Box sx={{ padding: '0 1em 0 1em' }}>
                <h3>There is no email address set for this user.<br/>Add the email in the app user settings.</h3>
              </Box>
        }
        {(!token || email) &&
          <>
          {token && email &&
            <Button type="button" onClick={handleBack} disabled={loading} sx={{ margin: '1em .5em 1em 0' }} >
              Back
            </Button>
          }
            <Button type="submit" variant="contained"color="primary" disabled={diabledSignIn} sx={{ margin: '1em 0' }} >
              {loading && (
                  <CircularProgress size={25} thickness={2} />
              )}
              {translate('ra.auth.sign_in')}
            </Button>
          </>
        }
          </Card>
      </Box>
    );
};

Login.propTypes = {
    authProvider: PropTypes.func,
    previousRoute: PropTypes.string,
};

export default Login;
